import React, { FC } from 'react';
import { Image } from 'react-bootstrap';

interface ImagePreviewProps {
  url: string;
}

export const ImagePreview: FC<ImagePreviewProps> = ({ url }) => {
  return (
    <>
      <Image src={url} alt="Person working at a desk" fluid />
    </>
  );
};
